import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "disconnect",
  "use": "disconnect-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"disconnect\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.667 4.667h-1.28c-.56 0-1.054.563-1.054 1.153v3.667c0 .545.552 1.18 1.053 1.18H7M12.353 10.667h1.28c.56 0 1.053-.564 1.053-1.153V5.846c0-.545-.552-1.18-1.053-1.18H9.02M4.667 2l6.666 11.333M10.667 7.667H12M4 7.667h1.333\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol